var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var internal_exports = {};
__export(internal_exports, {
  agentPolicy: () => import_agentPolicy.agentPolicy,
  agentPolicyName: () => import_agentPolicy.agentPolicyName,
  decompressResponsePolicy: () => import_decompressResponsePolicy.decompressResponsePolicy,
  decompressResponsePolicyName: () => import_decompressResponsePolicy.decompressResponsePolicyName,
  defaultRetryPolicy: () => import_defaultRetryPolicy.defaultRetryPolicy,
  defaultRetryPolicyName: () => import_defaultRetryPolicy.defaultRetryPolicyName,
  exponentialRetryPolicy: () => import_exponentialRetryPolicy.exponentialRetryPolicy,
  exponentialRetryPolicyName: () => import_exponentialRetryPolicy.exponentialRetryPolicyName,
  formDataPolicy: () => import_formDataPolicy.formDataPolicy,
  formDataPolicyName: () => import_formDataPolicy.formDataPolicyName,
  getDefaultProxySettings: () => import_proxyPolicy.getDefaultProxySettings,
  logPolicy: () => import_logPolicy.logPolicy,
  logPolicyName: () => import_logPolicy.logPolicyName,
  multipartPolicy: () => import_multipartPolicy.multipartPolicy,
  multipartPolicyName: () => import_multipartPolicy.multipartPolicyName,
  proxyPolicy: () => import_proxyPolicy.proxyPolicy,
  proxyPolicyName: () => import_proxyPolicy.proxyPolicyName,
  redirectPolicy: () => import_redirectPolicy.redirectPolicy,
  redirectPolicyName: () => import_redirectPolicy.redirectPolicyName,
  retryPolicy: () => import_retryPolicy.retryPolicy,
  systemErrorRetryPolicy: () => import_systemErrorRetryPolicy.systemErrorRetryPolicy,
  systemErrorRetryPolicyName: () => import_systemErrorRetryPolicy.systemErrorRetryPolicyName,
  throttlingRetryPolicy: () => import_throttlingRetryPolicy.throttlingRetryPolicy,
  throttlingRetryPolicyName: () => import_throttlingRetryPolicy.throttlingRetryPolicyName,
  tlsPolicy: () => import_tlsPolicy.tlsPolicy,
  tlsPolicyName: () => import_tlsPolicy.tlsPolicyName,
  userAgentPolicy: () => import_userAgentPolicy.userAgentPolicy,
  userAgentPolicyName: () => import_userAgentPolicy.userAgentPolicyName
});
module.exports = __toCommonJS(internal_exports);
var import_agentPolicy = require("./agentPolicy.js");
var import_decompressResponsePolicy = require("./decompressResponsePolicy.js");
var import_defaultRetryPolicy = require("./defaultRetryPolicy.js");
var import_exponentialRetryPolicy = require("./exponentialRetryPolicy.js");
var import_retryPolicy = require("./retryPolicy.js");
var import_systemErrorRetryPolicy = require("./systemErrorRetryPolicy.js");
var import_throttlingRetryPolicy = require("./throttlingRetryPolicy.js");
var import_formDataPolicy = require("./formDataPolicy.js");
var import_logPolicy = require("./logPolicy.js");
var import_multipartPolicy = require("./multipartPolicy.js");
var import_proxyPolicy = require("./proxyPolicy.js");
var import_redirectPolicy = require("./redirectPolicy.js");
var import_tlsPolicy = require("./tlsPolicy.js");
var import_userAgentPolicy = require("./userAgentPolicy.js");
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  agentPolicy,
  agentPolicyName,
  decompressResponsePolicy,
  decompressResponsePolicyName,
  defaultRetryPolicy,
  defaultRetryPolicyName,
  exponentialRetryPolicy,
  exponentialRetryPolicyName,
  formDataPolicy,
  formDataPolicyName,
  getDefaultProxySettings,
  logPolicy,
  logPolicyName,
  multipartPolicy,
  multipartPolicyName,
  proxyPolicy,
  proxyPolicyName,
  redirectPolicy,
  redirectPolicyName,
  retryPolicy,
  systemErrorRetryPolicy,
  systemErrorRetryPolicyName,
  throttlingRetryPolicy,
  throttlingRetryPolicyName,
  tlsPolicy,
  tlsPolicyName,
  userAgentPolicy,
  userAgentPolicyName
});
